import { Component, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
    selector: 'ngx-formly-multilang',
    templateUrl: './formly-multilang.component.html',
    styleUrls: ['./formly-multilang.component.scss']
})
export class FormlyMultilangComponent extends FieldType {

    get fieldKey(): string {
        if (Array.isArray(this.key)) {
            return this.key[0];
        }
        return '' + this.key;
    }

}
